import React, { lazy, Component, Suspense } from "react";
import autoBind from "auto-bind";
import axios from "axios";
import { withTranslation } from "react-i18next";
import { IBILoader } from "./components/UIComponents/IBILoader";
import { isPathPublicViewer } from "./Utilities/generalUtilities";
import { ToastNotification, showToast } from "./components/DesignSystem/Toast";
import { connect } from "react-redux";
import { dynamicModuleNames, isLocalEnvironment, getBackendBaseUrl } from "./constants";
import { getCurrentCity, setIsUserLoggedIn } from "actions/City";
import { timedErrorPopUp } from "components/commonUtilities";
import isEqual from "lodash/isEqual";
import { CenterContent } from "components/DesignSystem/GlobalStyle";
import { ACCESS_TOKEN } from "./constants";
import { getIframeConfigToken } from "./components/commonUtilities";
import { toast } from "react-toastify";
import i18next from "i18next";
export const globalDict = {};

const Main = lazy(() => import("./components/Main"));

class App extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            isRequestCompleted: false,
            redirectToLogin: null
        };
        this.isUserAuthenticated = false;

        this.checkLoginAPI = "/api/checklogin/";
        this.origin = getBackendBaseUrl();
    }
    updateSize() {
        if (document.getElementsByClassName("app-body")[0]) {
            document.getElementsByClassName("app-body")[0].style.height = `${window.innerHeight}px`;
        }
    }

    render() {
        const { isRequestCompleted, redirectToLogin } = this.state;
        const { t } = this.props;
        const redirectToLoginValue =
            redirectToLogin === null ? (
                <CenterContent className="w-100">{t("Please Wait")}...</CenterContent>
            ) : (
                <Suspense fallback={IBILoader}>
                    <ToastNotification />
                    <Main isUserAuthenticated={this.isUserAuthenticated} />
                </Suspense>
            );

        return (
            <>
                {!isRequestCompleted ? (
                    <CenterContent className="w-100">
                        <IBILoader />
                    </CenterContent>
                ) : (
                    redirectToLoginValue
                )}
            </>
        );
    }

    componentDidUpdate(prevProps, props) {
        const { isCurrentCityReceived, cityConfig } = this.props;
        if (prevProps.isCurrentCityReceived !== isCurrentCityReceived && isCurrentCityReceived) {
            const { t } = this.props;
            if (localStorage.getItem("termsAndConditionsAgreed") === null) {
                localStorage.setItem("termsAndConditionsAgreed", "false");
            }
            if (isLocalEnvironment) {
                try {
                    const baseURL = process.env.REACT_APP_BASE_URL,
                        AuthToken = process.env.REACT_APP_AUTH_TOKEN;
                    if (!(baseURL && AuthToken)) {
                        alert(t("Please include baseURL and AuthToken in LocalSettings"));

                        return;
                    }

                    if (!baseURL) {
                        alert(t("Please include baseURL in LocalSettings"));

                        return;
                    }

                    if (!AuthToken) {
                        alert(t("Please include AuthToken in LocalSettings"));

                        return;
                    }

                    axios.defaults.baseURL = baseURL;
                    axios.defaults.headers.common.Authorization = AuthToken;
                    localStorage.setItem("isUserAuthenticated", "true");
                    this.isUserAuthenticated = true;
                    this.setState({
                        redirectToLogin: false,
                        isRequestCompleted: true
                    });
                } catch (e) {
                    alert(t("Please include LocalSettings file"));
                }
            }
        }
        if (!isEqual(prevProps.cityConfig, cityConfig)) {
            if (isLocalEnvironment) {
                return;
            }
            const authToken = getIframeConfigToken();
            if (authToken) {
                axios.defaults.baseURL = this.origin;
                axios.defaults.headers.common.Authorization = `Token ${authToken}`;
                localStorage.setItem("isUserAuthenticated", "true");
                this.isUserAuthenticated = true;
                this.setState({
                    redirectToLogin: false,
                    isRequestCompleted: true
                });
            } else if (
                isPathPublicViewer() ||
                (this.props.currentCity.modules_enabled.includes(dynamicModuleNames.pfcv) &&
                    window.location.pathname === "/")
            ) {
                localStorage.setItem("isUserAuthenticated", "true");
                this.isUserAuthenticated = true;
                this.setState({
                    redirectToLogin: false,
                    isRequestCompleted: true
                });
            } else {
                // If accessToken is present, then user is logged in, it might have expired,
                // but it can be updated using refresh token
                if (localStorage.getItem(ACCESS_TOKEN)) {
                    localStorage.setItem("isUserAuthenticated", "true");
                    this.isUserAuthenticated = true;
                    this.setState({
                        redirectToLogin: false,
                        isRequestCompleted: true
                    });
                } else {
                    localStorage.setItem("isUserAuthenticated", "false");
                    this.isUserAuthenticated = false;
                    this.setState({
                        redirectToLogin: true,
                        isRequestCompleted: true
                    });
                }
            }
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateSize);
        this.updateSize();

        localStorage.setItem("isUserAuthenticated", "false");

        //if a cached page is served, reload it
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                window.location.reload();
            }
        });

        window.addEventListener("offline", (event) => {
            i18next.t(
                showToast(
                    "Network connection is unavailable. Please check your internet connection and try again.",
                    {
                        autoClose: 5000,
                        toastId: "network-toast",
                        type: "error"
                    }
                )
            );
            window.isOnline = false;
        });

        window.addEventListener("online", (event) => {
            window.isOnline = true;
            toast.dismiss("network-toast");
        });

        window.addEventListener("load", (event) => (window.isOnline = true));

        if (isLocalEnvironment) {
            try {
                const baseURL = process.env.REACT_APP_BASE_URL,
                    AuthToken = process.env.REACT_APP_AUTH_TOKEN;
                if (!(baseURL && AuthToken)) {
                    alert("Please include baseURL and AuthToken in LocalSettings");

                    return;
                }

                if (!baseURL) {
                    alert("Please include baseURL in LocalSettings");

                    return;
                }

                if (!AuthToken) {
                    alert("Please include AuthToken in LocalSettings");

                    return;
                }
                axios.defaults.baseURL = baseURL;
                axios.defaults.headers.common.Authorization = AuthToken;
            } catch (e) {
                timedErrorPopUp(e);
                console.log(e);
            }
        } else {
            axios.defaults.withCredentials = true;
            axios.defaults.baseURL = this.origin;
        }
        this.props.getCurrentCity();
    }
}

const mapStateToProps = (state) => {
    const { city } = state;

    return {
        isCurrentCityReceived: city.isCurrentCityReceived,
        currentCity: city.currentCity,
        cityConfig: city.cityConfig
    };
};

const mapDispatchToProps = {
    getCurrentCity,
    setIsUserLoggedIn
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
